import { useState } from "react";

import { Tabs, TabsContent, TabsList } from "@/components/ui/tabs";
import { Invoice } from "@/features/invoices/types/invoices";

import InvoiceTable from "./InvoiceTable";

interface LicenseeContentProps {
  invoices: Invoice[];
  isLoading: boolean;
  onDownloadInvoice: (invoiceId: string) => void;
  onInvoiceRowClick?: (invoice: Invoice) => void;
  onRecurringIconClick?: (recurringInvoiceId: string) => void;
}
const LicenseeContent = ({
  invoices,
  isLoading,
  onDownloadInvoice,
  onInvoiceRowClick,
  onRecurringIconClick,
}: LicenseeContentProps) => {
  const [activeTab, setActiveTab] = useState("invoices");
  return (
    <div className="h-full">
      <Tabs
        defaultValue="invoices"
        value={activeTab}
        onValueChange={setActiveTab}
        className="w-full h-full"
      >
        <TabsContent value="invoices" className="mt-2">
          <InvoiceTable
            invoices={invoices}
            isLoading={isLoading}
            onDownloadInvoice={onDownloadInvoice}
            onRowClick={onInvoiceRowClick}
            onRecurringIconClick={onRecurringIconClick}
          />
        </TabsContent>

        {/* <TabsContent value="earnings" className="mt-2">
          <EarningsChart isLoading={isLoading} />
         </TabsContent> */}
      </Tabs>
    </div>
  );
};
export default LicenseeContent;
